/*
 * @Version: 1.2
 * @Author: admin
 * @Description: main
 * @Date: 2022-06-23 14:44:39
 * @LastEditors: sky
 * @LastEditTime: 2022-09-15 17:27:25
 */
import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import ArcoVue from "@arco-design/web-vue";
import ArcoVueIcon from "@arco-design/web-vue/es/icon";
//import "@arco-design/web-vue/es/message/style/css.js";
import "@arco-design/web-vue/dist/arco.css";
import globalComponents from "@/components";
import directive from "./directive";
import "@/assets/style/global.less";
import "@/assets/style/arco.less";
// 1. 引入 mitt，是一个函数
import mitt from 'mitt'
import NativeBridge from "./utils/jsBridge";
// 1. 引入 v-scale-screen
import VScaleScreen from 'v-scale-screen'
const Mit = mitt()

const app = createApp(App);
app.use(store);
app.use(ArcoVue);
app.use(ArcoVueIcon);
app.use(directive);
app.use(router);
app.use(globalComponents);
// app.use(VScaleScreen)
app.component('v-scale-screen', VScaleScreen)

app.config.globalProperties.$Bus = Mit
app.config.globalProperties.$NativeBridge = new NativeBridge();

// 设置固定的浏览器标题
document.title = "军人体能训练管理考核系统";

// 监听标题变化，确保标题始终为"军事体育考核系统"
const originalTitle = "军人体能训练管理考核系统";
Object.defineProperty(document, 'title', {
  get: function() {
    return originalTitle;
  },
  set: function(value) {
    // 阻止标题被修改，始终返回固定标题
    return originalTitle;
  }
});

// 添加全局错误处理
const handleGlobalErrors = () => {
  // 处理chunk加载失败
  window.addEventListener('unhandledrejection', event => {
    if (event.reason && typeof event.reason === 'object' && 'message' in event.reason && 
        typeof event.reason.message === 'string' && event.reason.message.includes('Loading chunk')) {
      console.warn('Chunk加载失败，尝试重新加载页面:', event.reason.message);
      event.preventDefault(); // 阻止默认错误处理
      // 延迟重试，避免无限循环
      setTimeout(() => {
        if (confirm('页面加载出现问题，是否重新加载？')) {
          window.location.reload();
        }
      }, 1000);
    }
  });

  // 处理全局错误
  window.addEventListener('error', event => {
    if (event.message && event.message.includes('Loading chunk')) {
      console.warn('Chunk加载错误:', event.message);
      event.preventDefault();
    }
  });

  // 处理Vue错误
  app.config.errorHandler = (err, vm, info) => {
    console.error('Vue错误:', err, info);
  };
};

app.mount("#app");

// 调用错误处理函数
handleGlobalErrors();
